import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Plaza from "./components/Plaza";
import Feed from "./components/Feed";
import Community from "./components/Community";
import Voices from "./components/Voices";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Plaza />
        <Feed />
        <Community />
        <Voices />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}